module.exports = `fragment social_media on Contentstack_social_media {
    youtube
    twitter
    instagram
    facebook
    linkedin
  }`;